import { WrapLabel } from '../textarea/styled';
import { FormLabel } from '../form-label';
import React from 'react';
import { RichTextEditor } from './rich-text-editor';
import { FormHelperText } from '../form-helper-text';
export function RichTextEditorField(props) {
    const errorMessage = props.invalid && (React.createElement(FormHelperText, { msgType: "error", "data-testid": "rich-text-editor-error-message" }, props.errorMessage));
    return (React.createElement("div", null,
        React.createElement(WrapLabel, null, props.label && (React.createElement(FormLabel, { labelTooltip: props.labelTooltip, required: props.required }, props.label))),
        React.createElement(RichTextEditor, { ...props }),
        errorMessage));
}
